import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { RiLogoutBoxRFill } from "react-icons/ri"
import { BsPersonHeart } from "react-icons/bs";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./actions/auth.js";
import { GiHamburger, GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import { FaUserLarge } from "react-icons/fa6";

const Nav = styled.div`
background: #0b2948;
height: 40px;
display: flex;
justify-content: flex-start;
align-items: center;
font-size: 12px;
`;

const NavIcon = styled(Link)`
margin-left: 2rem;
font-size: 2rem;
height: 80px;
display: flex;
justify-content: flex-start;
align-items: center;
`;

const SidebarNav = styled.nav`
background: #15171c;
width: 250px;
height: 100vh;
display: flex;
justify-content: center;
position: fixed;
top: 0;
left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
transition: 350ms;
z-index: 10;
`;

const SidebarWrap = styled.div`
width: 100%;
`;

const Sidebar = () => {
	const [sidebar, setSidebar] = useState(false);
	const [useradmin, setUserAdmin] = useState(false);
	const [userb, setUserB] = useState(false);
	const [usera, setUserA] = useState(false);
	//const boxRef = useRef(null);
	//const boxOutsideClick = OutsideClick(boxRef);

	const showSidebar = () => setSidebar(!sidebar);
	const { user: currentUser } = useSelector((state) => state.auth);
	const dispatch = useDispatch();

	useEffect(() => {
		if (currentUser) {
			// these are the role ids from roles table
			setUserAdmin(currentUser.roles.includes(3));
			setUserB(currentUser.roles.includes(1));
			setUserA(currentUser.roles.includes(2));
		}
	}, [currentUser]);
	

	const handleLogout = () => {
		
		dispatch(logout())
		.then(() => {
			//props.history.push("/");
			//window.location.reload();
			window.location.assign("/");
		})
		.catch((e) => {
			console.log(e);
		});
	};	


	return (
		
		<>	
		<IconContext.Provider value={{ color: "white" }}> {/**ref={boxRef} */}
			<Nav>			
				<h5
					style={{width: "100%", 
							textAlign: "center",
							marginLeft: "0%",
							color: "#fff" }}
				>
					
				</h5>



				<div style={{marginLeft:'20px',marginRight:'20px',verticalAlign:'center', borderStyle:'solid',borderWidth:'2px', borderColor:'white',borderRadius:'20px'}}>
					<Link to="/userprofile" className="mr-2">
						<FaUserLarge 
							style={{cursor:'pointer'}}
							color="white"        
							size={25}>
						</FaUserLarge>                          
					</Link>             
				</div>

				<div style={{width:"60px"}}>

					<RiLogoutBoxRFill 
					size={25}
					onClick={handleLogout}/>
				</div>
				
				{/*{boxOutsideClick ? "outside click" : "inside click"}*/}
			</Nav>	
			
			<SidebarNav sidebar={sidebar}>	
							
				<SidebarWrap>					
					
				</SidebarWrap>
			</SidebarNav>
		</IconContext.Provider>
		</>
	);
};

export default Sidebar;
